import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectMarginHolds } from '../../store/marginHoldSlice';

const UserMarginHolds = ({ userId }) => {
  // const dispatch = useDispatch();
  const marginHolds = useSelector(selectMarginHolds);
  //const accountBalance = useSelector(selectAccountBalance);

//   useEffect(() => {
//     if (userId) {
//       fetchMarginHoldsForUser(userId, dispatch);
//     }
//   }, [userId, dispatch]);

  return (
    <div style={{ marginTop: 24 }}>
      <h4 style={{ marginBottom: 12, color: '#d32f2f' }}>Margin Holds</h4>
      {marginHolds.length === 0 ? (
        <div style={{ color: '#888' }}>No margin holds found.</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', background: '#f8fafd' }}>
          <thead>
            <tr style={{ background: '#e3eaf2' }}>
              <th style={{ padding: 8, border: '1px solid #ddd' }}>Entity</th>
              <th style={{ padding: 8, border: '1px solid #ddd' }}>Quantity</th>
              <th style={{ padding: 8, border: '1px solid #ddd' }}>Price</th>
              <th style={{ padding: 8, border: '1px solid #ddd' }}>Hold Amount</th>
              <th style={{ padding: 8, border: '1px solid #ddd' }}>Status</th>
              <th style={{ padding: 8, border: '1px solid #ddd' }}>Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {marginHolds.map(hold => (
              <tr key={hold.id}>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{hold.entityName}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{hold.quantity}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>${hold.price?.toFixed(2)}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>${hold.holdAmount?.toFixed(2)}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{hold.status}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{new Date(hold.timestamp).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserMarginHolds;
